// custom_cart_drawer.js

(function(){
  // Cache DOM
  const drawer    = document.getElementById("CartDrawer");
  const overlay   = document.getElementById("CartDrawerOverlay");
  const openBtns  = document.querySelectorAll(".header__cart-icon--lgD, .header__cart-icon--mobile");
  const crossBtn  = document.getElementById("cart-drawer__close_id");
  const cancelBtn = document.getElementById("cart-drawer__cancel_id");

  // Helpers to target sections of the drawer
  function drawerItemsContainer()    { return drawer.querySelector(".cart-drawer__items"); }
  function drawerNoteContainer()     { return drawer.querySelector(".cart-drawer__note"); }
  function drawerSubtotalContainer() { return drawer.querySelector(".cart-drawer__subtotal-wrapper"); }

  // GSAP-based open/close
  function openDrawer() {
    overlay.style.pointerEvents = "auto";
    gsap.to(overlay, { opacity: 1, duration: 0.3 });
    gsap.to(drawer,  { xPercent: -100, duration: 0.3, ease: "power2.out" });
  }
  function closeDrawer() {
    gsap.to(overlay, {
      opacity: 0, duration: 0.3,
      onComplete: () => overlay.style.pointerEvents = "none"
    });
    gsap.to(drawer, { xPercent: 100, duration: 0.3, ease: "power2.in" });
  }

  // Loading placeholder
  function showLoadingState() {
    const items = drawerItemsContainer();
    if (items) items.innerHTML = '<p class="cart-drawer__loading">Loading...</p>';
    if (drawerNoteContainer())     drawerNoteContainer().style.visibility     = "hidden";
    if (drawerSubtotalContainer()) drawerSubtotalContainer().style.visibility = "hidden";
  }
  function hideLoadingState() {
    if (drawerNoteContainer())     drawerNoteContainer().style.visibility     = "";
    if (drawerSubtotalContainer()) drawerSubtotalContainer().style.visibility = "";
  }

  // Fetch & replace drawer content
  function refreshCartDrawer() {
    return fetch("/cart?view=drawer")
      .then(r => r.text())
      .then(html => {
        const doc       = new DOMParser().parseFromString(html, "text/html");
        const newItems  = doc.querySelector(".cart-drawer__items");
        const newNote   = doc.querySelector(".cart-drawer__note");
        const newSubtot = doc.querySelector(".cart-drawer__subtotal-wrapper");

        if (newItems && drawerItemsContainer())    drawerItemsContainer().replaceWith(newItems);
        if (newNote  && drawerNoteContainer())     drawerNoteContainer().replaceWith(newNote);
        if (newSubtot && drawerSubtotalContainer()) drawerSubtotalContainer().replaceWith(newSubtot);

        return fetch("/cart.js")
          .then(r => r.json())
          .then(cart => {
            const countEl = document.querySelector(".header__cart-count");
            if (countEl) countEl.textContent = cart.item_count;
          })
          .finally(hideLoadingState);
      })
      .catch(err => {
        console.error("Failed to refresh cart drawer:", err);
        hideLoadingState();
      });
  }

  // Expose a single global function
  window.openUpdatedCartDrawer = function() {
    openDrawer();
    showLoadingState();
    return refreshCartDrawer();
  };

  // Wire up the open buttons to use it
  openBtns.forEach(btn => {
    if (!btn) return;
    btn.addEventListener("click", e => {
      e.preventDefault();
      window.openUpdatedCartDrawer();
    });
  });

  // Close handlers
  if (crossBtn)  crossBtn.addEventListener("click", e => { e.preventDefault(); closeDrawer(); });
  if (cancelBtn) cancelBtn.addEventListener("click", e => { e.preventDefault(); closeDrawer(); });
  overlay.addEventListener("click", closeDrawer);
  document.addEventListener("keydown", e => { if (e.key === "Escape") closeDrawer(); });

  // (Your existing drawer delegate logic for qty/remove/note remains unchanged)


   // Delegate quantity change and removal inside the drawer
  drawer.addEventListener("click", function (e) {
    // Quantity +/- buttons
    const qtyBtn = e.target.closest(".qty-btn");
    if (qtyBtn) {
      const item = qtyBtn.closest(".cart-drawer__item");
      const line = parseInt(item.dataset.line, 10);
      const input = item.querySelector(".qty-input");
      let qty = parseInt(input.value, 10);
      qty = qtyBtn.classList.contains("qty-btn--plus") ? qty + 1 : qty - 1;
      if (qty < 1) return;
      input.value = qty;

      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line, quantity: qty })
      })
        .then(r => r.json())
        .then(refreshCartDrawer)
        .catch(err => console.error("Quantity update failed:", err));

      return;
    }

    // Remove item
    const removeBtn = e.target.closest(".cart-drawer__remove");
    if (removeBtn) {
      const item = removeBtn.closest(".cart-drawer__item");
      const line = parseInt(item.dataset.line, 10);

      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line, quantity: 0 })
      })
        .then(r => r.json())
        .then(refreshCartDrawer)
        .catch(err => console.error("Remove item failed:", err));

      return;
    }
  });

  // Save order note
  drawer.addEventListener("change", function (e) {
    if (!e.target.matches("#CartNote")) return;
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ note: e.target.value })
    })
    .catch(err => console.error("Save note failed:", err));
  });








})();
